










































































import { Component, Watch } from 'vue-property-decorator'
import api from "../../api/index"
import Lists from '../components/Lists.vue'
import DelegationForm from '../components/forms/DelegationForm.vue'

@Component({
  components: { DelegationForm }
})
export default class DelegationList extends Lists {
  isLoading = true
  delegations = []
  formActive = false

  wordSearched = ""

  get totalRows() {
    return this.delegations.length < this.perPage ? this.delegations.length : this.perPage
  }

  goToDelegation(row: any) {
    this.$router.push({ name: 'delegationProfile', params: { delegationId: row.id } })
  }

  @Watch('perPage')
  @Watch('wordSearched')
  @Watch('currentPage')
  onSearchPropsChanged(val: any, old: any) {
    if ((old && val && val.toString() === old.toString()) || this.isLoading) {
      return
    }
    this.getAllDelegations()
  }

  async fetchData() {
    this.getAllDelegations()
  }

  async getAllDelegations() {
    try {
      const res = await api.get("bo/delegations", { params: {
        page: this.currentPage,
        per_page: this.perPage,
        keywords: this.wordSearched,
        order: this.sortField,
        order_desc: this.sortOrder
      }})
      this.totalPages = parseInt(res.headers["x-pagination-total-pages"])
      this.totalResults = parseInt(res.headers["x-pagination-total"])
      this.perPage = parseInt(res.headers["x-pagination-per-page"])

      this.delegations = res.data
    } catch (e) {
      if (e.response.status !== 200) {
        console.log(e.response.status)
      }
    }
  }

  async mounted() {
    await api.setToken()
    this.isLoading = true
    await this.getAllDelegations()
    this.isLoading = false
  }

  onDelegationCreated() {
    this.formActive = false
    this.getAllDelegations()
  }
}
